import type { KcContext } from "../login/KcContext";

export function addRegUrlParamToUrl(url: string, kcContext: KcContext): string {
    const regUrl = kcContext.regUrl || '';
    const hrefUrl = new URL(url, window.location.origin);

    if (regUrl && !hrefUrl.searchParams.has("reg_url")) {
        hrefUrl.searchParams.set("reg_url", regUrl);
    }
    return hrefUrl.toString();
}
